import clsx from 'clsx'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import SolidTagAltIcon from 'LuxKit/Icons/solid/SolidTagAltIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'

import { rem } from 'polished'
import styled from 'styled-components'

const MarkerContainer = styled.div`
  position: relative;
  border-radius: ${(props) => props.theme.borderRadius.round};
  padding: ${rem(4)} ${rem(8)};
  background-color: ${(props) => props.theme.palette.neutral.surface.normalBackground};
  box-shadow: ${(props) => props.theme.shadow.bottom.small};
  border: 1px solid ${(props) => props.theme.palette.neutral.surface.darkForeground};
  transition: padding 140ms ease-out, box-shadow 140ms ease-out;

  &.active,
  &:hover
  {
    font-weight: ${(props) => props.theme.font.primary.weight.bold};
    padding: ${rem(4.75)} ${rem(8.75)};
    box-shadow: ${(props) => props.theme.shadow.bottom.medium};
  }

  &.luxPlus {
    color: ${(props) => props.theme.palette.product.luxPlus.foreground};
  }

  &.hovered {
    background-color: ${(props) => props.theme.palette.neutral.surface.darkBackground};
    border: 1px solid ${(props) => props.theme.palette.neutral.surface.normalBackground};
    color: ${(props) => props.theme.palette.neutral.surface.darkContrast};
  }

  &.hovered.luxPlus {
    color: ${(props) => props.theme.palette.highlight.luxPlus.normalForeground};
  }
`

interface Props {
  isActive: boolean
  isHovered?: boolean
  label?: string
  discount?: number
  isVisited: boolean
  isLuxPlusPrice?: boolean
}

function PropertyPriceMarker(props: Props) {
  const {
    isActive,
    isHovered = false,
    label,
    discount,
    isVisited,
    isLuxPlusPrice = false,
  } = props
  const active = isActive || isHovered
  const icon = discount && !!label && <SolidTagAltIcon size="S" colour="highlight-primary" />

  return (
    <MarkerContainer
      className={clsx({
        active,
        visited: isVisited,
        luxPlus: isLuxPlusPrice,
        hovered: isHovered,
      })}
    >
      {label && <BodyTextBlock startIcon={icon} variant="medium">
        {label}
      </BodyTextBlock>}
      {!label && <LineBedIcon size="S" />}
    </MarkerContainer>
  )
}

export default PropertyPriceMarker
